import gql from 'graphql-tag';

export const deleteMemoMutation = gql`
    mutation deleteMemo($memoId: ID!) {
        deleteMemo(id: $memoId) {
            id
        }
    }`;
